<!--
상품을 반품처리 한다.
------------------------------------
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4 class="uk-text-center">반품신청서 작성</h4>
            </div>

            <div class="uk-modal-body uk-padding-remove uk-flex uk-flex-between uk-child-width-1-2 uk-flex-top">

                <!-- 상품정보 표시 -->
                <div class="uk-flex uk-padding-small">
                    <div class="uk-width-auto uk-text-center">
                        <div class="uk-margin-right">
                            <img
                                :src="prod.img_url"
                                width="100"
                            />

                            <!-- 라벨표시 -->
                            <div class="uk-margin-top">
                                <span v-show="prod.lock_error" class="uk-label uk-label-danger">오류</span>
                                <span v-show="prod.lock_hold" class="uk-label uk-label-danger">보류중</span>
                            </div>
                        </div>

                    </div>
                    <div class="uk-width-expand">

                        <app-column
                            class="uk-margin-small-bottom"
                            header="배송단계"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.state_text }}
                        </app-column>


                        <app-column
                            class="uk-margin-small-bottom"
                            header="상품번호"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.id }}
                        </app-column>

                        <app-column
                            class="uk-margin-small-bottom"
                            header="상품명"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.name }}
                        </app-column>

                        <app-column
                            class="uk-margin-small-bottom"
                            header="색상"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.color }}
                        </app-column>

                        <app-column
                            class="uk-margin-small-bottom"
                            header="사이즈"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.size }}
                        </app-column>



                        <app-column
                            class="uk-margin-small-bottom"
                            header="보관장소"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.storage }}
                        </app-column>

                        <app-column
                            class="uk-margin-small-bottom"
                            header="수량"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.amount }}
                        </app-column>

                    </div>
                </div>


                <!-- 안내 -->
                <div class="uk-padding-small" style="border-left: 1px solid #eee">
                    <div class="mb-1rem highlight-yellow" v-if="centerIsJpn">반품운임이 <span class="text-blue font-bold">선불/착불(판매처와 반드시 확인 필요)</span> 인지 확인 후 선택하세요</div>
                    <div class="uk-flex uk-flex-top uk-margin-bottom">


                        <app-input-ex
                            v-if="centerIsJpn"

                            class="uk-width-expand"
                            type="radio"
                            label="반품운임 지급방법"

                            :options="this.freightChargeTypeOptions"
                            v-model="inputs.freight_charge_type"
                        >
                            <div slot="label" class="">반품운임 지급방법</div>
                        </app-input-ex>

                        <app-input-ex
                            class="w-10rem mr-1rem"
                            type="text"
                            label="반품기한(현지시간)"
                            placeholder="e.g. 2023-01-01"
                            v-model="inputs.return_deadline_local"
                        ></app-input-ex>

                    </div>


                    <app-input-ex
                        class="uk-margin-bottom"
                        type="textarea"
                        label="반품 요청사항"
                        placeholder=""
                        :textarea-rows="4"
                        v-model="inputs.req_memo"
                    >
                        <div slot="customPlaceholder" class="uk-padding-xsmall" >
                            <div class="uk-text-muted">작업자에게 전달할 내용을 구체적으로 작성하세요.</div>
                        </div>
                    </app-input-ex>


                    <app-input-ex
                        class="uk-margin"
                        type="select"
                        label="반품사유"
                        :options="this.reasonTypeOptions"
                        v-model="inputs.reason_type"
                    ></app-input-ex>


                    <app-input-ex
                        class="uk-margin-bottom"
                        type="textarea"
                        label="상세사유"
                        placeholder="상세한 반품사유를 직접 작성하세요"
                        :textarea-rows="3"
                        v-model="inputs.reason_memo"
                    ></app-input-ex>


                </div>
            </div>


            <div class="uk-modal-footer">
              <!-- 업로드 모듈 -->
              <app-file-uploader
                  class="uk-margin-bottom"
                  header-text="반품라벨 업로드"
                  hide-add-phone-button

                  :csrf-token="csrfToken"
                  :type="99"
                  v-on:update:ids="val => inputs.file_ids = val"
              ></app-file-uploader>
            </div>

            <div class="uk-modal-footer uk-text-right">
                <div class="uk-margin-bottom">
                    * 합배송 상품인 경우, 다른 상품과 나눔배송 처리됩니다
                </div>

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    반품신청(완료)
                </button>
            </div>
        </div>
    </div>

</template>

<script>
    import regionAble from "../common/region-able.vue";
    import {get_region} from "../../../classes/region-factory";

    export default {
        mixins: [
            regionAble,
        ],
        props: {
            // csrf-token
            csrfToken: String,

        },
        data: function () {
            return {
                // (object) 상품정보
                prod: {},

                /**
                 * 반품사유 옵션
                 * (변동가능성이 많이 없어보여서 하드코딩함. 변동가능성이 생기면 추후에 ajax loading 처리함)
                 */
                reasonTypeOptions: [
                    {text: '단순변심', val: '1'},
                    {text: '하자', val: '2'},
                    {text: '오배송', val: '3'},
                    {text: '기타', val: '4'},
                ],

                /**
                 * 반품운임 종류 옵션
                 * (변동가능성이 많이 없어보여서 하드코딩함. 변동가능성이 생기면 추후에 ajax loading 처리함)
                 */
                freightChargeTypeOptions: [
                    //{text: '정보없음', val: '0'},
                    {text: '선불', val: '1'},
                    {text: '착불', val: '2'},
                    {text: 'PICK-UP', val: '3'},
                ],

                /**
                 * 입력값
                 */
                inputs: {},
            };
        },
        computed: {
            /**
             * 지역
             * @return {Region}
             */
            region: function () {
                return get_region(this.prod.region_id);
            },

            /**
             * 일본센터인지 여부
             * @return bool
             */
            centerIsJpn() {
                if (this.region === null) {
                    return false;
                }
                return this.region.country === 'JPN';
            },
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {

                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param prod_id 상품ID
             */
            form(prod_id) {

                // 초기화
                this.inputs = {
                    req_memo: null,
                    return_deadline_local: null,
                    reason_type: '1',
                    freight_charge_type: null,
                    reason_memo: null,
                    file_ids: [],
                };

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/prods/' + prod_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.prod = response.prod;

                    // 폼띄우기
                    this.displayForm();
                });
            },

            /**
             * submit
             */
            submit() {

                // promise 생성
                let load = new Promise((resolve, reject) => {

                    // 일본센터 검증
                    if (this.centerIsJpn) {
                        if (! this.inputs.freight_charge_type) {
                            alert('선불/착불을 선택하세요');
                            return;
                        }
                    }


                    // ajax 옵션
                    let opts = {
                        type: 'post',
                        url: '/return-infos',
                        data: _.merge({
                            '_token': this.csrfToken,
                            'prod_id': this.prod.id,
                            'type': 1, // 1: 현지반품
                        }, this.inputs),
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });

                // promise 처리
                load.then((response) => {
                    UIkit.modal.alert(response.msg).then(() => {
                        $.app.move('/prods/' + this.prod.id + '/return-info');
                    });
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>